export default __webpack_public_path__ + "static/blob12-881eb758343c06f13582677809557936.svg";